const form = {
  formId: "new-user-form",
  formField: {
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    ariseTimes: {
      name: "ariseTimes",
      label: "[01a] Lần phát sinh",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn lần phát sinh",
    },
    date: {
      name: "date",
      label: "[01b]",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    checkbox1: {
      name: "checkbox1",
      label: "Cá nhân được miễn, giảm thuế theo Hiệp định tránh đánh thuế hai lần (*)",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn",
    },
    checkbox2: {
      name: "checkbox2",
      label: "Khai thay cho nhiều cá nhân chuyển nhượng vốn góp",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn",
    },
    checkbox3: {
      name: "checkbox3",
      label: "Khai thay cho nhiều cá nhân chuyển nhượng chứng khoán",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn",
    },
    taxId1: {
      name: "taxId1",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxpayerName2: {
      name: "taxpayerName2",
      label: "[12] Tên tổ chức, cá nhân khai thay (nếu có)",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    address: {
      name: "address",
      label: "[14] Địa chỉ:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    address2: {
      name: "address2",
      label: "[31] Địa chỉ:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    district: {
      name: "district",
      label: "[15] Quận/huyện",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    province: {
      name: "province",
      label: "[16] Tỉnh/thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    district2: {
      name: "district2",
      label: "[32] Quận/huyện",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    province2: {
      name: "province2",
      label: "[33] Tỉnh/thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    phone: {
      name: "phone",
      label: "[17] Điện thoại:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax: {
      name: "fax",
      label: "[18] Fax:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email: {
      name: "email",
      label: "[19] Email:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    phone2: {
      name: "phone2",
      label: "[34] Điện thoại:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax2: {
      name: "fax2",
      label: "[35] Fax:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email2: {
      name: "email2",
      label: "[36] Email:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    taxId2: {
      name: "taxId2",
      label: "[13] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[20] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
    },
    organizationName: {
      name: "organizationName",
      label: "[29] Tên tổ chức phát hành",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên tổ chức phát hành",
    },
    taxId3: {
      name: "taxId3",
      label: "[30] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[21] Mã số thuế đại lý:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    // foot
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
